import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import DeleteModal from '@components/DeleteModal';
import EditDesignBasicInfo from '@components/designBasicInfo/EditDesignBasicInfo';
import NoData from '@components/NoData';
import { toastError, toastSuccess } from '@components/Toast';

import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';

import ApiClient from '@lib/apiClient';

import { convertDateToLocal, getShortName } from '@utils/Util';

import { BASE_FRONT_END_URL } from '@/constants/constant';

const Product = ({ productList = [], isPopupView, callback, supplierId, requestFrom, onEditInfo }) => {
	const [isUpdateCollection, setIsUpdateCollection] = useState(false);
	const [openConfirmationModal, setConfirmationModal] = useState(false);
	const [selectedId, setSelectedId] = useState(null);
	const [designIdToView, setDesignIdToView] = useState(null);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const onEditBasicInfo = (product) => {
		if (requestFrom === 'SUPPLIER_DETAILS') {
			onEditInfo(product);
		} else {
			setIsUpdateCollection(true);
		}
	};

	const onCancelModal = () => {
		setIsUpdateCollection(false);
	};

	const onUpdateDesignImage = () => {};

	const removeDesign = () => {
		ApiClient.DELETE_WITH_BODY('fetchGarments', {}, `/${supplierId}/${selectedId}`)
			.then(({ data }) => {
				callback(0);
				setSelectedId(null);
				setConfirmationModal(false);
				toastSuccess(data.message);
			})
			.catch(({ response }) => {
				setConfirmationModal(false);
				toastError(response.data.message);
			});
	};

	useEffect(() => {
		if (designIdToView !== null) {
			openDesignViewModal();
		}
	}, [designIdToView]);

	const openDesignViewModal = () => {
		dispatch(
			setDesignViewModalInfo({
				id: designIdToView,
				onCloseViewModal: () => {
					setDesignIdToView(null);
					dispatch(clearDesignViewModalInfo({}));
				},
				onUpdateCostingStatus: () => false,
				updateProductStatus: () => false,
				source: 'OTHERS'
			})
		);
	};

	const productsToRender = isPopupView ? productList : (productList || []).slice(0, 8);
	return productsToRender?.length === 0 ? (
		<NoData message="No key products added" />
	) : (
		productsToRender?.map((product) => (
			<div className={`${isPopupView ? '' : 'col-md-3 px-2 single-item'}`} key={`Id-${product.id}`}>
				<div className={'single-design-card with-editable shadow-1dp'}>
					<div className="card-top">
						<div className="edit-items">
							<div className="select-and-edit d-flex justify-content-end">
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
											aria-expanded="false"
											onClick={(e) => e.stopPropagation()}
										>
											<svg
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
													fill="#6A7181"
												/>
											</svg>
										</button>
										<ul
											className="dropdown-menu dropdown-menu-right shadow-lg"
											role="menu"
											aria-labelledby="menu1"
											x-placement="bottom-end"
										>
											<li role="presentation" className="px-4 pb-3 pt-3">
												<span
													role="menuitem"
													tabIndex="-1"
													className="font-weight-normal  text-black"
													onClick={() => {
														navigator.clipboard.writeText(
															`${BASE_FRONT_END_URL}/collections/list?openDesign=true&productId=${product.id}`
														);
														toastSuccess('Copied');
													}}
												>
													Copy design link
												</span>
											</li>
											<li role="presentation" className="px-4 pb-3 pt-3">
												<span
													role="menuitem"
													tabIndex="-1"
													className="font-weight-normal  text-black"
													onClick={() => {
														navigator.clipboard.writeText(
															product?.referenceNumber
														);
														toastSuccess('Copied');
													}}
												>
													Copy design number
												</span>
											</li>
											<li role="presentation" className="px-4 pb-3 pt-3">
												<span
													role="menuitem"
													tabIndex="-1"
													className="font-weight-normal  text-black"
													onClick={() => onEditBasicInfo(product)}
												>
													Edit basic info
												</span>
											</li>
											<li role="presentation" className="px-4 pb-3 pt-3">
												<a
													role="menuitem"
													tabIndex="-1"
													className="font-weight-normal  text-black"
													onClick={(e) => {
														e.stopPropagation();
														localStorage.setItem('fromRoute', location.pathname);
														navigate(`/designs/edit/${product.id}`);
													}}
													href={void 0}
												>
													Edit design
												</a>
											</li>
											<li role="presentation" className="px-4 pb-3">
												<span
													role="menuitem"
													tabIndex="-1"
													className="font-weight-normal  text-black"
													onClick={(e) => {
														e.stopPropagation();
														setSelectedId(product.id);
														setConfirmationModal(true);
													}}
												>
													Delete
												</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
							{isUpdateCollection && (
								<EditDesignBasicInfo
									isEditAllFields={true}
									onCancelModal={onCancelModal}
									productId={product.id}
									onUpdateDesignImage={onUpdateDesignImage}
									onUpdateBasicInfo={() => callback(0)}
								/>
							)}
						</div>
						<img
							src={product.featureImageUrl}
							className="card-image"
							data-toggle="modal"
							data-target="#designViewModal"
							onClick={() => {
								setDesignIdToView(product.id);
							}}
							alt="modal-view"
						/>
					</div>
					<div className="card-content">
						<div className="card-info">
							<span className="status">
								<span className="title-number">{product?.referenceNumber}&nbsp;&nbsp;</span>
								<span className="title-number">
									{product?.seasonName ? product?.seasonName : product?.season}&nbsp;&nbsp;
								</span>
								{product?.numberOfResold > 0 && (
									<>
										<span className="sold">
											Sold <span className="count">{product?.numberOfResold}</span>{' '}
										</span>
										<ul className="solded-items shadow-4dp">
											{product?.orderRefNumbers?.map((item) => (
												<li key={item.orderId}>
													<Link
														to={`/orders/view/${item.orderId}`}
														key={item.orderId}
													>
														{item?.orderRefNumber}
													</Link>
												</li>
											))}
										</ul>
									</>
								)}
								<ul className="common-list-component mt-1">
									<li>
										<span className="gray_dark_02">{product?.brandName}</span>
									</li>
									<li>
										<span className="gray_dark_02">{product?.subCategory}</span>
									</li>
									<li>
										<Tooltip
											title={<span className="regular-14">{product.addedByName}</span>}
											placement="top"
											arrow
										>
											<span className="mb-0 regular-12 gray_dark_02 ">
												{getShortName(product.addedByName, 10)}
											</span>
										</Tooltip>
										<span className="gray_dark_03">
											&nbsp;{convertDateToLocal(product.addedAt, 'Do MMM YY')}
										</span>
									</li>
								</ul>
							</span>
						</div>
					</div>
				</div>
				{openConfirmationModal && (
					<DeleteModal onRemove={removeDesign} onClose={() => setConfirmationModal(false)} />
				)}
			</div>
		))
	);
};

export default Product;
